export enum EntityTypes {
  Body = 'Body',
  Section = 'Section',
  Row = 'Row',
  Column = 'Column',
  Image = 'Image',
  Text = 'Text',
  Button = 'Button',
  HorizontalLine = 'HorizontalLine',
}
